import React from 'react';

/* ── Sceau de Bobine — Signature visuelle dorée (logo miniature) ── */
export const BobineSceau = ({ size = 22, style = {} }) => (
  <img
    src="/bobine-face-logo.png"
    alt=""
    style={{ width: size, height: size, objectFit: 'contain', flexShrink: 0, ...style }}
  />
);

/* ── Tooltip doré au survol d'un sceau — identique à Bobine Vive ── */
export const SceauButton = ({ tooltip, children, onClick, style = {}, testId, active, showLabel, ...props }) => {
  return (
    <div
      className="sceau-btn-wrap"
      style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, minWidth: 0 }}
    >
      <button
        onClick={(e) => { if (onClick) onClick(e); e.currentTarget.blur(); }}
        data-testid={testId}
        style={{
          display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer',
          fontFamily: "'Georgia', serif", fontSize: 12, borderRadius: 6,
          padding: '6px 8px', transition: 'background-color 0.2s, border-color 0.2s',
          backgroundColor: active ? '#D4AF37' : 'transparent',
          color: active ? '#000' : '#D4AF37',
          border: active ? '1.5px solid #D4AF37' : '1px solid rgba(212,175,55,0.25)',
          WebkitTapHighlightColor: 'transparent',
          outline: 'none',
          position: 'relative',
          ...style,
        }}
        {...props}
      >
        {children}
      </button>
      {/* Label visible — toujours affiché */}
      {showLabel && tooltip && (
        <span style={{
          fontFamily: "'Georgia', serif", fontSize: 10, color: active ? '#D4AF37' : '#D4AF37',
          textAlign: 'center', lineHeight: 1.1, maxWidth: 70, overflow: 'hidden',
          textOverflow: 'ellipsis', whiteSpace: 'nowrap', letterSpacing: 0.2,
        }}>
          {tooltip}
        </span>
      )}
      {/* Tooltip hover desktop only */}
      {tooltip && !showLabel && (
        <div className="sceau-tip" style={{
          position: 'absolute', bottom: '120%', left: '50%', transform: 'translateX(-50%)',
          backgroundColor: 'rgba(10,10,10,0.95)', border: '1px solid rgba(212,175,55,0.4)',
          borderRadius: 8, padding: '8px 14px', whiteSpace: 'nowrap', zIndex: 100,
          pointerEvents: 'none', opacity: 0, transition: 'opacity 0.25s',
          boxShadow: '0 4px 16px rgba(0,0,0,0.5)',
        }}>
          <span style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37' }}>
            {tooltip}
          </span>
        </div>
      )}
      <style>{`.sceau-btn-wrap:hover .sceau-tip { opacity: 1 !important; }`}</style>
    </div>
  );
};

/* ── Mini-sceau indicateur pour les miniatures ── */
export const SceauIndicator = ({ type, style = {} }) => (
  <div style={{
    display: 'flex', alignItems: 'center', gap: 3,
    backgroundColor: 'rgba(0,0,0,0.75)', borderRadius: 12,
    padding: '3px 7px', border: '1px solid rgba(212,175,55,0.3)',
    ...style,
  }}>
    <img src="/bobine-face-logo.png" alt="" style={{ width: 12, height: 12, objectFit: 'contain' }} />
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round">
      {type === 'audio' && <>
        <path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/>
        <path d="M19 10v2a7 7 0 01-14 0v-2"/>
      </>}
      {type === 'comment' && <>
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
      </>}
    </svg>
  </div>
);
